import { makeAutoObservable, reaction } from "mobx";
import { ServerError } from "../models/ServerError";

export default class CommonStore {
    error: ServerError | null = null;
    token: string | null = sessionStorage.getItem('gv-pf-base-jwt');
    appLoaded = false;

    constructor() {
        makeAutoObservable(this);

        // this reaction only runs when token changes
        // this will make the token persist on page refresh/redirects
        reaction(
            () => this.token, 
            token => {
                if (token)
                {
                    sessionStorage.setItem('gv-pf-base-jwt', token);
                } 
                else 
                {
                    sessionStorage.removeItem('gv-pf-base-jwt');
                }
            }
        )
    }
    
    setServerError(error: ServerError) {
        this.error = error;
    }

    setToken = (token : string | null) => {
        this.token = token;
    }

    setAppLoaded = () => {
        this.appLoaded = true;
    }
   
}